/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class FileUploadDownloadService extends HttpHandlerService {

        private $q: ng.IQService;
        private $timeout: ng.ITimeoutService;
        private upload: any;

        private errorMsg = "The file upload was unsuccessful";
        
        constructor($http: ng.IHttpService, $q: ng.IQService, $timeout: ng.ITimeoutService, upload: any) {
            super($http);
            this.$q = $q;
            this.$timeout = $timeout;
            this.upload = upload;
        }

        public uploadFiles(files: any, model: models.FileUploadModel): ng.IPromise<Wars.Domain.Model.Dtos.DocumentDto[]> {
            var url = "./api/document";
            return this.commonUpload(files, model, url);
        }

        public uploadProcessLevelStaticFiles(files: any, model: models.FileUploadModel): ng.IPromise<Wars.Domain.Model.Dtos.DocumentDto[]> {
            var url = './api/document/processConfiguration/' + model.processConfigId;
            return this.commonUpload(files, model, url);
        }

        public uploadSystemLevelStaticFiles(files: any, model: models.FileUploadModel): ng.IPromise<Wars.Domain.Model.Dtos.DocumentDto[]> {
            var url = './api/document/systemLevel/' + model.systemLevelId;
            return this.commonUpload(files, model, url);
        }

        public getSecuredDocumentKey(docMetadataId: string): ng.IPromise<string> {
            var params: any = {};
            this.handlerUrl = "./api/document/" + docMetadataId + "/SecuredDocumentKey";
            return this.useGetHandler(params);
        }

        public deleteDocument(id: string) : ng.IPromise<any> {
            var params: any = {};
            this.handlerUrl = "./api/document/Delete/" + id;
            return this.usePostHandler(params);
        }

        public editIsSecure(docId: string, manageDocumentConfigUniqueId: string, isSecure: boolean) {
            var params: any = {};
            this.handlerUrl = "./api/document/EditIsSecure/" + docId + "/" + manageDocumentConfigUniqueId + "/" + isSecure;
            return this.usePostHandler(params);
        }

        public updateDocumentMetadata(
            documents: Wars.Domain.Model.Dtos.DocumentDto[],
            documentConnections: Wars.Domain.Model.Dtos.DocumentConnectionsDto,
            previousDocumentIds: string[],
            isTemporary: boolean) : ng.IPromise<Wars.Domain.Model.Dtos.DocumentDto[]>
        {
            var params: any = {
                documents: documents,
                documentConnections,
                previousDocumentIds,
                isTemporary
            };
            this.handlerUrl = "./api/document/DocumentMetadata/Process/" + documentConnections.processId;
            return this.usePostHandler(params);
        }

        private commonUpload(files: any, model: models.FileUploadModel, url: string): ng.IPromise<Wars.Domain.Model.Dtos.DocumentDto[]> {
            model.errorMessage = undefined;
            var d = this.$q.defer();

            if (files && files.length) {
                this.upload.upload({
                    url: url,
                    data: {files: files}
                }).then(
                    (response) => { this.$timeout(() => { d.resolve(response.data); }); },
                    () => { 
                        model.errorMessage = this.errorMsg;
                        model.fileUploadProgress = undefined;
                        d.resolve(undefined);
                    },
                    (evt: any) => {
                        model.fileUploadProgress = Math.min(100, 100.0 * (evt.loaded / evt.total));
                    });
            }
            return d.promise;
        }
    }
}

warsApp.registerService('FileUploadDownloadService', ['$http', '$q', '$timeout', 'Upload']);